import { z } from 'zod';

/** Placeholder — extend when adding user-specific validation. */
export const userSliceSchema = z.object({ id: z.number().optional() });
export type userSliceSchemaValues = z.infer<typeof userSliceSchema>;
